import { ToggleButton, ToggleButtonProps, styled } from '@mui/material';
import React from 'react';

// Make value optional in our component props by extending ToggleButtonProps
// and making the value property optional
export type RoundedToggleButtonProps = Omit<ToggleButtonProps, 'value'> & {
  value: ToggleButtonProps['value'];
};
export type Ref = HTMLButtonElement;

const StyledRoundedToggleButtonRoot = styled(ToggleButton)(({ theme }) => ({
  borderRadius: '50px !important',
  borderColor: theme.palette.primary.main,
  fontWeight: 400,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  borderWidth: '1px',
  borderLeftColor: `${theme.palette.primary.main} !important`,
  padding: theme.spacing(1, 1.5),
}));

type StyledRoundedToggleButtonComponent = React.ForwardRefExoticComponent<
  ToggleButtonProps & React.RefAttributes<HTMLButtonElement>
>;

const ForwardedStyledRoundedToggleButton = React.forwardRef<
  HTMLButtonElement,
  ToggleButtonProps
>((props, ref) => <StyledRoundedToggleButtonRoot {...props} ref={ref} />);

ForwardedStyledRoundedToggleButton.displayName = 'StyledRoundedToggleButton';

export const StyledRoundedToggleButton: StyledRoundedToggleButtonComponent =
  ForwardedStyledRoundedToggleButton;

export const RoundedToggleButton = React.forwardRef<
  Ref,
  RoundedToggleButtonProps
>((props, ref) => {
  // Provide an empty string as default value if not specified
  const valueProps = props.value === undefined ? { value: '' } : {};
  return <StyledRoundedToggleButton {...props} {...valueProps} ref={ref} />;
});
